import { Component, Inject, OnInit } from '@angular/core';
import { FormControl, UntypedFormBuilder, UntypedFormGroup } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

import { Site } from '@shared/models';

interface DialogField {
  label: string;
  inputType: any;
  patternErrorText?: string;
  control: FormControl;
}

interface DialogFormData {
  title: string;
  fields: Record<string, DialogField>;
}

@Component({
  selector: 'fc-dialog-form',
  templateUrl: './dialog-form.component.html',
  styleUrl: './dialog-form.component.scss',
  standalone: false
})
export class DialogFormComponent implements OnInit {
  dialogForm: UntypedFormGroup;
  site: Site;
  keepOriginalOrder = () => 0;

  constructor(
    public dialogRef: MatDialogRef<DialogFormComponent>,
    readonly formBuilder: UntypedFormBuilder,
    @Inject(MAT_DIALOG_DATA) public data: DialogFormData
  ) {
  }

  ngOnInit(): void {
    const group = Object.fromEntries(
      Object.entries(this.data.fields)
        .map(([key, field]) => [key, field.control])
    );
    this.dialogForm = this.formBuilder.group(group);
  }

  onNoClick(): void {
    this.dialogRef.close();
  }

  onSubmit() {
    this.dialogRef.close(this.dialogForm.value);
  }
}
